import { Button, Colors, IcEdit, IcTrash } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import useGetDetailStore from 'modules/store/services/hooks/useGetDetailStore';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import StoreInfoMobile from './StoreInfoMobile';
import StoreResources from './StoreResources';
import navigate from 'utils/navigate';

const DetailStoreMobile = () => {
  const { id } = useParams<{ id: string }>();
  const { detailStore } = useGetDetailStore(id || '');

  const handleEditStore = () => {
    navigate(`/store/edit/${id}`);
  };
  
  return (
    <Container>
      <HeaderMobile title='Store Details' />
      <Content>
        <StoreInfoMobile detailStore={detailStore} />
        <StoreResources />
      </Content>
      <FooterMobile>
        <Button type_delete lg prefix={<IcTrash fill={Colors.other[3]} width={20} height={20}/>}>Delete</Button>
        <Button type_new lg prefix={<IcEdit fill={Colors.primary[5]} width={20} height={20}/>} onClick={handleEditStore}>
          Edit
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default DetailStoreMobile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.neutral.bg[1]};
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
